// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Collaborators_collaborators__Ty0Xv .Collaborators_collaborator__xedYm {
  background: white;
  padding: 15px 20px;
  border-radius: 5px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}
.Collaborators_collaborators__Ty0Xv .Collaborators_collaborator__xedYm .Collaborators_avatar__irMsE {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 20px;
}
.Collaborators_collaborators__Ty0Xv .Collaborators_collaborator__xedYm .Collaborators_avatar__irMsE .Collaborators_photo__Vg4pn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}
.Collaborators_collaborators__Ty0Xv .Collaborators_collaborator__xedYm .Collaborators_info__uDMMT p {
  margin-bottom: 3px !important;
}
.Collaborators_collaborators__Ty0Xv .Collaborators_collaborator__xedYm .Collaborators_info__uDMMT .Collaborators_name__QKOG4 {
  font-weight: bold;
  cursor: pointer;
}
.Collaborators_collaborators__Ty0Xv .Collaborators_collaborator__xedYm .Collaborators_info__uDMMT .Collaborators_name__QKOG4:hover {
  text-decoration: underline;
  color: var(--blue);
}
.Collaborators_collaborators__Ty0Xv .Collaborators_collaborator__xedYm .Collaborators_info__uDMMT p {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Collaborators/Collaborators.module.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAER;AAEM;EACE,6BAAA;AAAR;AAGM;EACE,iBAAA;EACA,eAAA;AADR;AAIM;EACE,0BAAA;EACA,kBAAA;AAFR;AAKM;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAHR","sourcesContent":[".collaborators {\n  .collaborator {\n    background: white;\n    padding: 15px 20px;\n    border-radius: 5px;\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 25px;\n    .avatar {\n      width: 60px;\n      height: 60px;\n      position: relative;\n      margin-right: 20px;\n      .photo {\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n    }\n    .info {\n      p {\n        margin-bottom: 3px !important;\n      }\n\n      .name {\n        font-weight: bold;\n        cursor: pointer;\n      }\n\n      .name:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 6;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collaborators": `Collaborators_collaborators__Ty0Xv`,
	"collaborator": `Collaborators_collaborator__xedYm`,
	"avatar": `Collaborators_avatar__irMsE`,
	"photo": `Collaborators_photo__Vg4pn`,
	"info": `Collaborators_info__uDMMT`,
	"name": `Collaborators_name__QKOG4`
};
export default ___CSS_LOADER_EXPORT___;
